import { Http } from '@/lib/http';
import data from './mockdata.json'

export class DashboardMockDataService extends Http {
  constructor() {
    super();
  }

  fetchData() {
    return data
  }
}